import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, map } from 'rxjs'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { ApiResponsePaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-response.interface'
import { SmartQuoteFavouriteFilter } from 'src/app/shared/interfaces/smartquote-favourite/smartquote-favourite-filter.interface'
import { SmartQuoteFavourite } from 'src/app/shared/interfaces/smartquote-favourite/smartquote-favourite.interface'
import { environment } from 'src/environments/environment'
import { getPagedFilterParams } from '../../helpers/get-filters'

@Injectable({
    providedIn: 'root',
})
export class SmartquoteFavouriteService {
    private httpClient = inject(HttpClient)

    getFavourites(filter: SmartQuoteFavouriteFilter): Observable<PaginatedList<SmartQuoteFavourite>> {
        const params = getPagedFilterParams(filter)

        return this.httpClient
            .get<ApiResponsePaginatedList<SmartQuoteFavourite>>(`${environment.baseUrl}smartQuote-favourites`, {
                params,
            })
            .pipe(map((x) => x.result))
    }

    createFavourite(req: { productId: number }): Observable<void> {
        return this.httpClient.post<void>(`${environment.baseUrl}smartQuote-favourites`, req)
    }

    deleteFavourite(id: number): Observable<void> {
        return this.httpClient.delete<void>(`${environment.baseUrl}smartQuote-favourites/${id}`)
    }
}
